import moment from 'moment'
import 'moment/locale/pt-br'
import { AppointmentStatus, PaymentMethods, AgendaWorkingTimeType } from 'lib/constants'

const _sortAppointments = (a1, a2) => {
  const isBefore = a1.appointmentYear < a2.appointmentYear
  || (a1.appointmentYear === a2.appointmentYear && a1.appointmentMonth < a2.appointmentMonth)
  || (a1.appointmentYear === a2.appointmentYear && a1.appointmentMonth === a2.appointmentMonth && a1.appointmentDay < a2.appointmentDay)
  ||  (a1.appointmentYear === a2.appointmentYear && a1.appointmentMonth === a2.appointmentMonth && a1.appointmentDay === a2.appointmentDay && a1.appointmentTime < a2.appointmentTime)
  return isBefore ? -1 : 1
}

export const getCurrentDate = () => {
  const now = moment()
  return {
    day: now.date(),
    month: now.month() + 1,
    year: now.year()
  }
}

export const getMonthAppointmentsSortedByDate = appointments => {
  const sortedAppointments = [...appointments].sort((a1, a2) => {
    if (a1.appointmentYear !== a2.appointmentYear) return a1.appointmentYear - a2.appointmentYear
    else if (a1.appointmentMonth !== a2.appointmentMonth) return a1.appointmentMonth - a2.appointmentMonth
    else if (a1.appointmentDay !== a2.appointmentDay) return a1.appointmentDay - a2.appointmentDay
    return a1.appointmentTime - a2.appointmentTime
  })

  const uniqueDates = sortedAppointments.filter((a1, index, self) =>
    self.findIndex(a2 => a1.appointmentYear === a2.appointmentYear && a1.appointmentMonth === a2.appointmentMonth && a1.appointmentDay === a2.appointmentDay) === index
  ).map(a => ({
    month: a.appointmentMonth, day: a.appointmentDay
  }))

  return uniqueDates.map(d => ({
    label: getDayOfMonth(d.day, d.month),
    appointments: sortedAppointments.filter(a => a.appointmentDay === d.day)
  }))
}

export const generateDateValues = (minYear, maxYear) => {
  const dates = []
  const date = moment()
  for (let y = minYear; y <= maxYear; y++) {
    for (let m = 1; m <= 12; m++) {
      date.month(m-1)
      dates.push({ year: y, month: m, value: `${y}_${m}`, label: `${date.format('MM')}/${y}` })
    }
  }
  return dates
}

export const getPrettyDate = date => moment(date).format('DD/MM/YYYY')
export const getDayOfMonth = (d, m) => moment(`${d}_${m}`, 'D_M').format('DD \\d\\e MMMM')
export const hourFromMinutes = min => moment().hours(0).seconds(0).minutes(parseInt(min, 10)).format('HH:mm')
export const minutesFromTime = date => {
  const d = moment(date)
  return d.hours() * 60 + d.minutes()
}

export const yearDifferenceFromNow = birthdate => {
  const now = moment();
  const dob = moment(birthdate)
  return now.diff(dob, 'years')
}

export const dateThreeMonthsFromNow = () => moment().add(3, 'months')
export const getWeekSpan = date => {
  const d = moment(date, 'DD/MM/YYYY')
  const end = d.endOf('isoweek').format('DD/MM/YYYY')
  const start = d.startOf('isoweek').format('DD/MM/YYYY')
  const startDate = { day: d.date(), month: d.month() + 1, year: d.year() }
  return { start, end, startDate }
}
export const getWeekdays = () => moment.weekdays()

export const appointmentsByDate = (appointments, startDate) => {
  const apd = []
  const start = moment(`${startDate.day}/${startDate.month}/${startDate.year}`, 'DD/MM/YYYY')
  const d = start
  const sorted = appointments.sort(_sortAppointments)
  // One week span
  for (let i = 0; i <= 6; i++) {
    const a = {
      day: {
        name: d.format('dddd'),
        date: d.format('DD/MM'),
        fullDate: { year: d.format('YYYY'), month: d.format('MM'), day: d.format('DD') }
      },
      appointments: sorted.filter(a => a.appointmentYear === d.year() && a.appointmentMonth === d.month() + 1 && a.appointmentDay === d.date())
    }
    d.add(1, 'days')
    apd.push(a)
  }
  return apd
}

export const canOpenAppointment = appointment => appointment.appointmentStatus === AppointmentStatus.Closed
export const canCloseAppointment = appointment => appointment.appointmentStatus === AppointmentStatus.Available
export const canCancelAppointment = appointment => appointment.appointmentStatus === AppointmentStatus.ReservedPaymentPending || appointment.appointmentStatus === AppointmentStatus.ReservedPaymentDone
export const canStartAppointment = appointment => {
   const { dtoReservedAppointment, appointmentStatus: status } = appointment
   if (!dtoReservedAppointment) return false
   return (status === AppointmentStatus.ReservedPaymentDone && appointment.isTelehealth)
 }   
export const canCompleteAppointment = appointment => {
   const { dtoReservedAppointment, appointmentStatus: status } = appointment
   if (!dtoReservedAppointment) return false
   const { oneClickClientPaymentMethod: paymentMethod } = dtoReservedAppointment
   return (paymentMethod === PaymentMethods.Cash && status === AppointmentStatus.ReservedPaymentPending)
   || status === AppointmentStatus.ReservedPaymentDone
 }
export const appointmentIsReserved = appointment => appointment.appointmentStatus !== AppointmentStatus.Available && appointment.appointmentStatus !== AppointmentStatus.Closed
export const filterReportAppointments = appointments => {
  return appointments.filter(
    a => a.appointmentStatus === AppointmentStatus.Completed
    || a.appointmentStatus === AppointmentStatus.ReservedPaymentDone
    || a.appointmentStatus === AppointmentStatus.ReservedPaymentPending
    || a.appointmentStatus === AppointmentStatus.CancelledByProfessional
    || a.appointmentStatus === AppointmentStatus.CancelledByClient
    || a.appointmentStatus === AppointmentStatus.CancelledByAdmin
  )
}
export const shouldShowPaymentMethod = appointment => {
  switch (appointment.appointmentStatus) {
    case AppointmentStatus.ReservedPaymentPending:
    case AppointmentStatus.ReservedPaymentDone:
    case AppointmentStatus.Completed:
    return true
    default:
    return false
  }
}

export const enableTimeslotControl = agenda => agenda.workingTimeType === AgendaWorkingTimeType.Manual



// WEBPACK FOOTER //
// ./src/lib/helper.js